import { z } from "zod";
//#region src/const/user.ts
const VerificationSource = {
	email: "email",
	external: "external",
	membership: "membership",
	payment: "payment"
};
const VerificationSourceEnum = z.enum(Object.values(VerificationSource));
//#endregion
export { VerificationSource, VerificationSourceEnum };
